import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ChangePasswordService } from './api/changePassword.service';
import { IdentityService } from './api/identity.service';
import { IdentityBranchService } from './api/identityBranch.service';
import { IdentityRegionService } from './api/identityRegion.service';
import { IdentityWarehouseService } from './api/identityWarehouse.service';
import { RoleService } from './api/role.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ChangePasswordService,
    IdentityService,
    IdentityBranchService,
    IdentityRegionService,
    IdentityWarehouseService,
    RoleService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
